import { tokenDestinationCard } from "./TokenDestinationCard";

export const RedditDestinationCard = tokenDestinationCard({
  type: "reddit",
  intro:
    "Server-side conversions to your Reddit pixel. Both values are in Reddit Ads under Events Manager: the pixel " +
    "ID on the pixel itself, and a conversion access token you generate under Conversions API. The token does " +
    "not expire, and it belongs to the business that generated it rather than to one pixel, so generate it in " +
    "the same business as the pixel you enter here.",
  fields: [
    {
      key: "pixelId",
      label: "Pixel ID",
      placeholder: "t2_abc123",
      helpText:
        "In Events Manager, open Configure data source, choose Conversions API, then Set up manually, and copy " +
        "the Pixel ID. Paste it exactly as Reddit gives it to you. Some accounts show it with a t2_ prefix and " +
        "some without, and both work.",
    },
    {
      key: "accessToken",
      label: "Conversion access token",
      secret: true,
      helpText: "Shown once when you generate it. Only a business admin can, and you can hold up to 25 at a time.",
    },
    {
      key: "testEventCode",
      label: "Test ID (optional)",
      optional: true,
      // HEDGED ON PURPOSE. Reddit documents how to use a test ID and that the
      // events appear under Events Testing. It does NOT document that they
      // are excluded from live reporting, attribution or billing, and saying
      // so would be a claim about a merchant's ad reports that nobody has
      // checked. Replace this wording once a live account settles it.
      helpText:
        "From Events Testing in Reddit Ads. Events sent with it show up there, which is how you confirm the " +
        "connection. Clear it when you are done: while one is saved, replays after an outage are held back.",
    },
  ],
  testNote:
    "Test sends a product view rather than a purchase, so pressing it cannot report a sale you did not make. " +
    "Two things to know before you turn this on. Reddit drops any event older than seven days without telling " +
    "us, so a replay after an outage only covers what fits in that window. And if you already run Reddit's own " +
    "pixel or its Shopify app, check what each one sends: Reddit merges two reports of one purchase only when " +
    "both carry the same conversion ID, and we cannot see what another app sends as one.",
});
